/* eslint-disable no-unreachable */
/* global emptyFamilonBasket dataLayer */

import $ from 'jquery';
import Mustache from 'mustache';
import store from '../vendor/store';

import '../vendor/jquery.waypoints';

import '../vendor/responsive.core';
import '../vendor/responsive.modal';
import '../vendor/responsive.tabs';
import '../vendor/responsive.tablelist';

/* WEBSHOP */

(function ($, Mustache, store) {

  const stageLanguage = $('html').attr('lang');

  var storage = store,
    templates = {
      headerBasket: $('#template-header-basket').html(),
      basket: $('#template-basket').html(),
      basketEmpty: $('#template-basket-empty').html(),
      notifyQuota: $('#template-quota-notify').html()
    };

  if ($('#blog-list').length) {
    removeQueryStringParam('show');

    $('#blog-list-load-more').click(function () {
      // var $self = $(this);

      var blog_list_item_template = $('#blog_list_item_template').html();

      $.ajax({
        url: '/stage-ajax/getBlogArticles/?stage-language=' + $('html').attr('lang'),
        method: 'POST',
        data: {
          title: $('#blog-list').data('title') ? $('#blog-list').data('title') : '',
          offset: $('#blog-list > article').length,
          category: $('#blog-list').data('category') ? $('#blog-list').data('category') : ''
        },
        dataType: 'json',
        success: function (data) {
          if (data.articles && data.articles.length) {
            $('#blog-list').append(Mustache.render(blog_list_item_template, data));
          }

          if (!data.articles || data.articles.length < 10) {
            $('#blog-list-load-more').remove();
          }
        },
        error: function (data) {
          console.log(data);
        }
      });
    });

    $('body').on('click', '#blog-list > article a', function (e) {
      e.preventDefault();

      if ($('#blog-list > article').length > 10) {
        updateQueryStringParam('show', $('#blog-list > article').length);
      }

      location.href = $(this).attr('href');
    });
  }

  function updateQueryStringParam(key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
      urlQueryString = document.location.search,
      newParam = key + '=' + value,
      params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var keyRegex = new RegExp('([?&])' + key + '[^&]*');

      // If param exists already, update it
      if (urlQueryString.match(keyRegex) !== null) {
        params = urlQueryString.replace(keyRegex, '$1' + newParam);
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }
    window.history.replaceState({}, '', baseUrl + params);
  }

  function removeQueryStringParam(key) {
    var urlParamRegex = new RegExp('[?&]' + key + '=[^&]+');
    history.replaceState && history.replaceState(
      null, '', location.pathname + location.search.replace(urlParamRegex, '').replace(/^&/, '?') + location.hash
    );
  }

  $('#size-variant').on('change', function (e) {
    $('#quota-notify > form > input[type=hidden]:nth-child(3)').val($(this).val());
  });
  /* ------------------------------------------------------------------------- */
  /*	Enhanced ecommerce
  /* ------------------------------------------------------------------------- */

  // Test localStorage support
  var isLocalStorageEnabled = function () {
    if (localStorage) {
      try {
        localStorage.setItem('webshopTestItem', 'webshopTestItem');
        localStorage.removeItem('webshopTestItem');
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  var GTM = (function () {
    //dataLayer defined in document header as global variable

    var eventTimeout = 2000,
      api = {};

    function isEnabled() {
      return (window.google_tag_manager && window.ga && window.ga.loaded);
    }

    api.isEnabled = isEnabled;

    function addToCart(id, name, ean, quantity, formattedPrice = 0, productColor = '', category = '') {
      dataLayer.push({
        ecommerce: null
      }); // Clear the previous ecommerce object

      var price = formattedPrice && typeof formattedPrice === 'string' ? formattedPrice.replace(/,/g, '.') : formattedPrice;
      price = parseFloat(price);

      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'EUR',
          add: {
            products: [{
              name: name,
              id: id,
              price: price,
              brand: 'Familon',
              variant: productColor,
              variant_id: ean,
              quantity: quantity,
              category: category
            }]
          }
        }
      });
    }
    api.addToCart = addToCart;

    function removeFromCart(id, name, ean, quantity, productColor = '') {
      dataLayer.push({
        ecommerce: null
      }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'removeFromCart',
        ecommerce: {
          remove: {
            products: [{
              name: name,
              id: id,
              variant: productColor,
              variant_id: ean,
              quantity: quantity,
              brand: 'Familon'
            }]
          }
        }
      });
    }
    api.removeFromCart = removeFromCart;

    function clickProduct(id, name, link, list) {
      dataLayer.push({
        ecommerce: null
      });
      dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: {
              list: list
            },
            products: [{
              id: id,
              name: name,
              brand: 'Familon'
            }]
          }
        },
        eventCallback: function () {
          document.location = link;
        },
        eventTimeout: eventTimeout
      });
    }
    api.clickProduct = clickProduct;

    function productImpression(id, name, list) {
      //dataLayer.push({ ecommerce: null });
      dataLayer.push({
        ecommerce: {
          impressions: [{
            name: name,
            id: id,
            brand: 'Familon',
            list: list
          }]
        }
      });
    }
    api.productImpression = productImpression;

    function clickPromo(id, name, link) {
      dataLayer.push({
        event: 'promotionClick',
        ecommerce: {
          promoClick: {
            promotions: [{
              id: id,
              name: name
            }]
          }
        },
        eventCallback: function () {
          document.location = link;
        }
      });
    }
    api.clickPromo = clickPromo;

    function promoImpression(id, name) {
      dataLayer.push({
        ecommerce: {
          promoView: {
            promotions: [{
              id: id,
              name: name
            }]
          }
        }
      });
    }
    api.promoImpression = promoImpression;

    return api;

  })();

  /**
   * Sends the current cart to Matomo dataLayer with the event 'addToCart'
   * @param {Array} products - Array of products currently in cart
   */
  function mtmAddToCart(products) {
    if (products.length > 0) {
      let productsToPush = [];
      products.map(function (product) {
        let price = product.formattedPrice && typeof formattedPrice === 'string' ? product.formattedPrice.replace(/,/g, '.') : product.price;
        let size = product.width && product.length ? product.width + ' x ' + product.length + ' cm' : '';
        price = parseFloat(price);
        productsToPush.push({
          name: product.name,
          id: product.pid,
          price: price,
          brand: 'Familon',
          variant: `${product.color}${size ? ' | ' + size : ''}`,
          variant_id: product.ean,
          quantity: product.amount,
          category: product.main_product_group_name
        });
      });
      window._mtm.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'EUR',
          add: {
            products: productsToPush
          }
        }
      });
    }
  }

  /**
   * Sends the current cart to Matomo dataLayer with the event 'removeFromCart'
   * @param {Array} products - Array of products currently in cart
   */
  function mtmRemoveFromCart(products) {
    let productsToPush = [];
    if (products.length > 0) {
      products.map(function (product) {
        let price = product.formattedPrice && typeof formattedPrice === 'string' ? product.formattedPrice.replace(/,/g, '.') : product.price;
        let size = product.width && product.length ? product.width + ' x ' + product.length + ' cm' : '';
        price = parseFloat(price);
        productsToPush.push({
          name: product.name,
          id: product.pid,
          price: price,
          brand: 'Familon',
          variant: `${product.color}${size ? ' | ' + size : ''}`,
          variant_id: product.ean,
          quantity: product.amount,
          category: product.main_product_group_name
        });
      });
    }
    window._mtm.push({
      event: 'removeFromCart',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: productsToPush
        }
      }
    });
  }

  /**
   * Sends information about the product that was clicked to Matomo dataLayer with the event 'productClick'
   * @param {number} id - Id of the product that was clicked
   * @param {string} name - Name of the product that was clicked
   * @param {string} list - Name of the list where the product was clicked
   */
  function mtmClickProduct(id, name, list) {
    window._mtm.push({
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: {
            list: list
          },
          products: [{
            id: id,
            name: name,
            brand: 'Familon'
          }]
        }
      },
      eventTimeout: 2000
    });
  }

  /**
   * Sends information about the promo that was clicked to Matomo dataLayer with the event 'productImpression'
   * @param {number} id - Id of the promo that was clicked
   * @param {string} name - Name of the promo that was clicked
   */
  function mtmClickPromo(id, name) {
    window._mtm.push({
      event: 'promotionClick',
      ecommerce: {
        promoClick: {
          promotions: [{
            id: id,
            name: name
          }]
        }
      },
    });
  }

  var waypointOffset = '75%';
  $('.products-grid__item__image').on({
    mouseenter: function () {
      var auxImg = $(this).next('.products-grid__item__auxiliary__image').attr('data-original');
      if (auxImg) {
        $(this).css('transition', 'background 0.2s linear').css('background-image', 'url(' + auxImg + ')').fadeIn();
      }
    },
    mouseleave: function () {
      var originalImg = $(this).attr('data-original');
      if (originalImg) {
        $(this).css('transition', 'background 0.2s linear').css('background-image', 'url(' + originalImg + ')').fadeIn();
      }
    }
  });

  //Record product list item click to GTM Enhanced ecommerce
  $('.products-grid').on('click', '.products-grid__item__link', function (e) {
    if (GTM.isEnabled()) {
      e.preventDefault();

      var elem = $(this),
        link = elem.attr('href'),
        id = link.split('-').pop().replace(/\D/g, ''), //Should always be pid
        name = $('.products-grid__item__name', elem).text().trim(),
        list = 'Product list';

      //Product clicked on search page
      if (elem.closest('.products-grid--search-results').length) {
        list = 'Search results';
      }

      mtmClickProduct(id, name, list);
      GTM.clickProduct(id, name, link, list);
    }
  });

  // Record product list item impression to GTM Enhanced ecommerce
  $('.products-grid .products-grid__item').waypoint(function () {
    if (GTM.isEnabled()) {
      var elem = $(this.element).find('.products-grid__item__link'),
        link = elem.attr('href'),
        id = link.split('-').pop().replace(/\D/g, ''), //Should always be pid
        name = $('.products-grid__item__name', elem).text().trim(),
        list = 'Product list';

      //Product viewed on search page
      if (elem.closest('.products-grid--search-results').length) {
        list = 'Search results';
      }

      GTM.productImpression(id, name, list);

      this.destroy(); // Don't trigger impression with this element anymore
    }
  }, {
    offset: waypointOffset
  });


  //// Promotions related stuff ////

  // Returns promo object to use in GTM (name and id)
  function getPromoName(elem) {
    if (elem.closest('.frontpage-slider__item').length > 0) {
      elem = elem.closest('.frontpage-slider__item').find('a.title-link p');
    } else if (elem.closest('.frontpage-boxes__item').find('.frontpage-boxes__title a').length > 0) {
      elem = elem.closest('.frontpage-boxes__item').find('.frontpage-boxes__title a');
    } else if ($('.banner__title, h3', elem).length > 0) {
      elem = $('.banner__title, h3', elem);
    } else if ($('span', elem).length > 0) {
      elem = $('span', elem);
    }

    var name = elem.text().replace(/^Katso myös: /, '').replace(/ >$/, '');
    name = name.replace(/\r?\n|\r/g, '').replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' '); // remove newlines, remove extra spaces
    name = name.substring(0, 60); // Get 60 first chars

    return name;
  }

  var promoSelectors = [
    '.popup-text a', // Frontpage: slick slider in the very top
    '.frontpage-slider .frontpage-slider__item a', // Frontpage: frontpage-slider
    '.frontpage-boxes .frontpage-boxes__item a', // Frontpage: category pages etc.
    '.campaigns .blog__listing-post__title a', // Campaigns on campaigns-page
    'a.campaign__cta-button', // Single campaign page: cta-buttons to other campaigns
    '.banner a.banner__link' // Banners in e.g. item list
  ];

  // Record promo clicks
  $(promoSelectors.join(', ')).click(function (e) {
    if (GTM.isEnabled()) {
      e.preventDefault();

      var elem = $(this),
        link = elem.attr('href'),
        id = link.split('/').slice(2, -1).join('-'),
        name = getPromoName(elem);

      mtmClickPromo(id, name);
      GTM.clickPromo(id, name, link);
    }
  });

  // Record promo impressions
  $(promoSelectors.join(', ')).waypoint(function () {
    if (GTM.isEnabled()) {
      var elem = $(this.element),
        link = elem.attr('href'),
        id = link.split('/').slice(2, -1).join('-'),
        name = getPromoName(elem);

      GTM.promoImpression(id, name);

      this.destroy(); // Don't trigger impression with this element anymore
    }
  }, {
    offset: waypointOffset
  });


  /* ------------------------------------------------------------------------- */
  /*	Header alert
  /* ------------------------------------------------------------------------- */

  $('.alert-text').slideDown('slow', function () {
    setTimeout(function () {
      $('.alert-text').slideUp('slow');
    }, 4000)
  });


  //Check if basket data is in localstorage
  //(header basket is in storage, so that
  //other pages except purchase funnel can be cached)
  try {
    if (typeof emptyFamilonBasket === 'undefined') {

      // Check for localStorage too because Safari may have cookied only partial basket (< 2K)
      if (storage && storage.get('myBasket') && isLocalStorageEnabled()) {
        var basketData = storage.get('myBasket');

        if (basketData && typeof basketData.products !== 'undefined') {
          //Check each product in basket for validity
          //(product reservation expires after three hours)
          var now = new Date().getTime(),
            validProducts = [],
            totalAmount = 0;

          $.each(basketData.products, function (i, product) {
            var expires = parseInt(product.expires, 10);
            if (expires > now) {
              validProducts.push(product);
              totalAmount += product.amount;
            }
          });

          if (totalAmount > 0) {
            //Update valid products
            basketData.products = validProducts;
            basketData.totalAmount = totalAmount;
            storage.set('myBasket', basketData);

            updateHeaderBasket(basketData);
          } else {
            //No valid products, remove whole basket
            storage.remove('myBasket');
          }
        }
      } else if (!isLocalStorageEnabled()) {
        // if localStorage is disabled and cookie can not be found, fetch with ajax
        updateHeaderBasket(null, false, true);
      }
    }
  } catch (e) {
    //Not.
  }

  //Empty localstorage on successful order (thank you page)
  try {
    if (typeof emptyFamilonBasket !== 'undefined' && emptyFamilonBasket) {
      if (storage && storage.get('myBasket')) {
        storage.remove('myBasket');
      }

      // eslint-disable-next-line no-undef
      typeof _giosg === 'function' && _giosg(function () {
        // eslint-disable-next-line no-undef
        giosg.api.shoppingCart.freeze().then(function () {
          // Frozen cart
        });
      });

    }
  } catch (e) {
    //Not.
  }

  $('form.stage-extranet').on('submit', function (e) {
    //Get new token
    var token = updateToken();
    this.cm_token.value = token;
  });

  /**
   * Removes classes that start with a prefix
   *
   * @param  {string} prefix - Class starts with this string
   *
   * @return {jQueryelem} el - Prefix element
   */
  $.fn.removeClassStartsWith = function (prefix) {
    var el = $(this);

    $.each(el, function (i, el) {
      var classes = $(el).attr('class').split(' ').filter(function (c) {
        return c.lastIndexOf(prefix, 0) !== 0;
      });
      $(el).attr('class', classes.join(' '));
    });

    return el;
  };

  /**
   * Gets a new token. Token can be used only once,
   * and a page may have multiple forms which require tokens.
   * When these are submitted via ajax, the new token
   * has to be fetched too since no pageload happens.
   *
   * @return {string} token - A new CSRF token
   */
  function updateToken() {
    var token = $.ajax({
      type: 'GET',
      url: '/stage-ajax/getToken/',
      async: false,
      cache: false
    }).responseText;

    return token;
  }

  function setTokens(token) {
    if (!token) {
      token = updateToken();
    }

    const tokenInputs = document.querySelectorAll('input[name="cm_token"]');
    for (let i=0;i<tokenInputs.length;i++) {
      tokenInputs[i].value = token;
    }
  }

  /**
   * Updates the header basket
   *
   * @param {object} basket - items in basket
   * @param {boolean} flash - Show the updated cart items popup briefly
   * @param {boolean} useAjaxFetch - fetch basket with ajax (if localStorage and cookie fail)
   */
  function updateHeaderBasket(basket, flash, useAjaxFetch) {
    let headerBasket = $('#header-basket');

    if (useAjaxFetch) {
      $.ajax({
        url: headerBasket.data('basket-ajax'),
        method: 'get',
        success: function (res) {

          storage.set('myBasket', res);
          basket = res;
          updateHeaderBasket(basket);
        }
      })
    }

    // Load giosg
    // eslint-disable-next-line no-undef
    typeof _giosg === 'function' && _giosg(function () {
      // eslint-disable-next-line no-undef
      giosg.api.shoppingCart.setCurrency('EUR');
      const productList = [];

      if (basket && typeof basket.products !== 'undefined') {
        let now = new Date().getTime(),
          validProducts = [],
          totalAmount = 0;

        $.each(basket.products, function (_i, product) {
          let expires = parseInt(product.expires, 10);
          if (expires > now) {
            validProducts.push(product);

            productList.push({
              name: String(product.name),
              quantity: product.amount,
              product_number: String(product.ean),
              price: (product.price).toFixed(2),
              category: String(product.main_product_group_name)
            });
            totalAmount += product.amount;
          }
        });

        if (totalAmount > 0) {
          //Update valid products
          basket.products = validProducts;
          basket.totalAmount = totalAmount;

          // eslint-disable-next-line no-undef
          giosg.api.shoppingCart.submit(productList).then(function () {
            // Cart submit/update
          });

        } else {
          // No valid products, clear cart
          // eslint-disable-next-line no-undef
          giosg.api.shoppingCart.clearCart();
        }
      }
    });

    headerBasket.html(Mustache.render(templates.headerBasket, basket));

    if (typeof flash !== 'undefined' && flash) {
      headerBasket.children('.shopping-cart-widget').addClass('-flash');
      setTimeout(function () {
        headerBasket.children('.shopping-cart-widget').removeClass('-flash');
      }, 1500);
    }
  }

  /**
   * Updates the "big" basket
   *
   * @param {object} basket - items in basket
   */
  function updateBasket(basket) {
    var basketContainer = $('.basket-container');

    if (basket.products.length > 0) {
      //Render basket again
      basketContainer.html(Mustache.render(templates.basket, basket));
    } else {
      //Empty basket
      basketContainer.html(Mustache.render(templates.basketEmpty));
    }
  }

  /**
   * Appends an alert box to the target element
   *
   * @param {string} msg         - Message to show
   * @param {jQueryelem} target  - Target element (appended inside this)
   * @param {string} status      - CSS class for different types of alerts.
   *                               E.g. error, info, success
   * @param {int} hideAfter      - Number of milliseconds to wait before
   *                               hiding the alert automatically
   */
  function showAlert(msg, target, status, hideAfter) {
    //Create alert
    $('<div class="a-alert' +
        (typeof status !== 'undefined' ? ' ' + status : '') +
        '" role="alert" />')
      .html('<p>' + msg + '</p>')
      .css('display', 'none')
      .appendTo($(target))
      .slideDown(200);

    //Automatic hide
    if (typeof hideAfter !== 'undefined') {
      setTimeout(function () {
        hideAlert($(target));
      }, hideAfter);
    }
  }

  /**
   * Hides an alert box from the target element
   *
   * @param {jQueryelem} target - Target element
   */
  function hideAlert(target) {
    $('.a-alert', $(target)).slideUp(200);
  }

  /* ------------------------------------------------------------------------- */
  /*  Product page
  /* ------------------------------------------------------------------------- */

  (function () {
    var addingProduct = false;

    //Don't bother if it's not a product page
    if ($('article.p-product-page').length === 0) {
      return false;
    }

    var $alertArea = $('form.js-product-add-to-cart .js-product-add-to-cart-alert');

    /**
     * Product variations logic
     */
    var $variations = $('.js-product-variations');
    var variationsObj = $variations.data('variations');

    $variations.on('change keyup', 'select', function () {
      var $select = $(this),
        value = $select.val();

      // Hide alert when changing anything
      hideAlert($alertArea);

      $('form.js-product-add-to-cart .js-product-add-to-cart-button').removeClass('added');

      // If variation is sold out, show modal and reset current select field and price
      if ($select.find(':selected').hasClass('sold-out')) {

        resetDropdowns($select);
        updatePrice(false);
        updateDeliveryTime(false);
      } else {
        // Check if there's more dropdown to select from
        var $dropdowns = $select.closest('.js-product-variations-dropdown').nextAll('.js-product-variations-dropdown');

        if ($dropdowns.length) {
          // Reset everything
          resetDropdowns($dropdowns.find('select'));
          updateEAN('');
          updatePrice(false);
          updateDeliveryTime(false);
          enableAddToCart(false);

          // Check first dropdown and update it options
          var $dropdown = $dropdowns.first();
          var variationEANs = value.split(','),
            variationChecks = [];

          // Check availibility
          $dropdown.find('option').each(function (i) {
            if ($(this).val()) {
              variationChecks.push(variationCheck($(this), variationEANs));
              updateAvailability($(this));
            }
          });

          // If at least one option is available, enable dropdown
          $dropdown.find('select').prop('disabled', (variationChecks.indexOf(true) === -1));

          // And if this isn't the last one, disable all the next ones
          if ($dropdowns.next().length) {
            $dropdowns.next().find('select').prop('disabled', true);
          }
          // No more dropdowns, update EAN, price and add to cart button
        } else {
          value = $select.find(':selected').data('selected-value') || value;

          // Make sure we have the correct EAN
          if ($variations.find('.js-product-variations-dropdown').length > 1) {
            var variationEANsArr = [];

            $variations.find('select').each(function () {
              variationEANsArr.push($(this).val().split(','));
            });

            value = variationEANsArr.shift().filter(function (v) {
              return variationEANsArr.every(function (a) {
                return a.indexOf(v) !== -1;
              });
            });
          }

          updateEAN(value);
          updatePrice(value);
          updateDeliveryTime(value);
          enableAddToCart(!!value);
        }
      }
    });

    // Disable all other dropdowns except the first one
    $variations.find('select:first').trigger('change');

    /**
     * Get the variation data object
     *
     * @param {String} ean - EAN of the product
     * @return {Object}
     */
    function getVariationInfo(ean) {
      if (ean) {
        return variationsObj[ean];
      }
    }

    /**
     * Check if variation is available (database) and update option element
     * Can also be resetted to default state
     *
     * @param {jQuery} $option - Product option in property dropdown
     * @param {Boolean} [reset] - Flag whether to reset to default state or not
     * @return {Boolean}
     */
    function updateAvailability($option, reset) {
      if ($option && $option.length) {
        var text = $option.removeClass('sold-out').data('text');

        if (!reset) {
          var variationEANs = ($option.data('selected-value') || $option.val()).split(',');
          var currentEAN = '';

          for (var i = 0; i < variationEANs.length; i++) {
            if (variationEANs[i] && getVariationInfo(variationEANs[i]).available) {
              currentEAN = variationEANs[i];
              break;
            }
          }

          if (!currentEAN) {
            $option.addClass('sold-out');
            text += ' ' + $variations.data('text-sold-out');
          }
        }

        $option.text(text);

        return reset ? true : !currentEAN;
      }
    }

    /**
     * Update EAN field with a atring
     *fw
     * @param {String} ean - EAN of the product variation
     */
    function updateEAN(ean) {
      if (typeof ean !== 'undefined') {
        $variations.find('[name="ean"]').val(ean);
      }
    }

    /**
     * Reset select field(s)
     *
     * @param {jQuery} $select - The dropdown element
     */
    function resetDropdowns($select) {
      if ($select && $select.length) {
        $select.each(function (i) {
          $(this).val('');
        });
      }
    }

    /**
     * Check if variation should be available (depending on previous selections)
     *
     * @param {jQuery} $option - Variation dropdown option
     * @param {Array} variationEANs - Array of product variation EANs
     * @return {Boolean}
     */
    function variationCheck($option, variationEANs) {
      if ($option && $option.length && variationEANs && variationEANs.length) {
        var currentEAN = '';

        for (var i = 0; i < variationEANs.length; i++) {
          if ($option.val().indexOf(variationEANs[i]) !== -1) {
            currentEAN = variationEANs[i];
            break;
          }
        }

        // Enable/disable option and set possible EAN
        $option.prop('disabled', !currentEAN)
          .data('selected-value', currentEAN);

        return !!currentEAN;
      }
    }

    /**
     * Enable/disable add to cart button
     *
     * @param {Boolean} enabled - Flag whether to enable or disable button
     */
    function enableAddToCart(enabled) {
      if (typeof enabled !== 'undefined') {
        $('.js-product-add-to-cart-button').toggleClass('-type-disabled', !enabled);
      }
    }

    /**
     * Update product price on variation change
     *
     * @param {String} ean - EAN of the product variation
     */
    function updatePrice(ean) {
      var $price = $('.js-product-price'),
        $starting = $('.js-product-price-starting'),
        $current = $('.js-product-price-current'),
        $original = $('.js-product-price-original'),
        $history = $('.js-product-price-history');

      if (ean) {
        var variation = getVariationInfo(ean);

        $starting.hide();
        $current.show().text(variation.formattedPrice + ' €');

        $('form.js-product-add-to-cart input[name="price"]').val(variation.formattedPrice);

        if (variation.formattedOriginalPrice) {
          $original.text(variation.formattedOriginalPrice + ' €');
        }

        $history.text(variation.formattedPriceHistory);
      } else {
        $starting.show();
        $current.text($price.data('starting-price') + ' €');

        if ($price.data('starting-original-price') + ' €') {
          $original.text($price.data('starting-original-price') + ' €');
        }
      }
    }

    /**
     * Update product delivery time on variation change
     *
     * @param {String} ean - EAN of the product variation
     */
    function updateDeliveryTime(ean) {
      var $deliveryTime = $('.js-product-delivery-time').removeClass('u-hidden');
      var $addToCart = $('.js-product-page-actions');
      var $outOfStock = $('.js-product-out-of-stock');
      var $quotaNotificationEanCode = $('.js-quota-notify-form input[name="ean"]');

      if (ean) {
        var variation = getVariationInfo(ean);

        if (variation.deliveryTimeName) {
          $deliveryTime.find('.js-product-delivery-time-color').css('background-color', variation.color);
          $deliveryTime.find('.js-product-delivery-time-text').text(variation.deliveryTimeName);
          if (variation.available === true) {
            $deliveryTime.show();
            $addToCart.show();
            $outOfStock.addClass('u-hidden').hide();
            $quotaNotificationEanCode.val('-1');
          } else {
            $addToCart.hide();
            $deliveryTime.hide();
            $outOfStock.removeClass('u-hidden').show();
            $quotaNotificationEanCode.val(ean);
          }
        } else {
          $deliveryTime.hide();
        }

      } else {
        $deliveryTime.hide();
      }
    }

    //Add to basket
    $('form.js-product-add-to-cart').on('submit', function (e) {
      e.preventDefault();

      var form = $(this);
      const variationSelects = form.find('.js-product-variant-select');

      //Prevent double clicks
      if (addingProduct) {
        return false;
      }

      // Hide previous alert
      hideAlert($alertArea);

      // Make sure all required selections have been made
      let selectionsMade = true;
      for (let i = 0; i < variationSelects.length; i++) {
        const $select = $(variationSelects[i]);
        if ($select.val() === '') {
          const message = $select.attr('data-text-required') || 'This field is required';
          showAlert(message, $alertArea, 'error');
          selectionsMade = false;
        }
      }

      if (!selectionsMade) {
        return false;
      }

      const addToCartButton = form.find('.js-product-add-to-cart-button');
      addToCartButton.removeClass('added');

      addingProduct = true;

      //Variables
      var ean = form.find('[name="ean"]').val(),
        productColor = form.find('[name="productColorName"]').val(),
        amount = parseInt(form.find('[name="amount"]').val()),
        id = form.find('[name="productId"]').val(),
        name = form.find('[name="name"]').val(),
        price = form.find('[name="price"]').val(),
        category = form.find('[name="category"]').val();

      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: {
          products: [{
            ean: ean,
            amount: amount
          }],
          token: form.find('[name="cm_token"]').val(),
          action: 'add',
          s: form.find('[name="s"]').val()
        },
        dataType: 'json',
        success: function (data) {
          data = data[0];

          if (data.status === 'SUCCESS') {
            storage.set('myBasket', data.basket);
            updateHeaderBasket(data.basket, true);

            addToCartButton.addClass('added');

            // Trigger click event for header cart
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width > 991) { // Only in desktop
              const headerCart = $('.js-header-cart');
              const cartToggle = headerCart.find('.js-cart-toggle');
              if (cartToggle.length) {
                cartToggle[0].click(); // Open cart

                setTimeout(function(){
                  if (headerCart.hasClass('is-visible-dropdown')) {
                    cartToggle[0].click(); // Hide cart
                  }
                }, 3000);
              }
            }

            //Enhanced ecommerce
            mtmAddToCart(data.basket.products);
            if (GTM.isEnabled()) {
              GTM.addToCart(id, name, ean, amount, price, productColor, category);
            }

          } else if (data.status === 'ERROR') {
            showAlert(data.txt, $alertArea, 'error');

            //Show email notification form is q
            if (data.code === 'TEMPORARILY_OUT_OF_STOCK') {

              var selectedOption = $('select#size option:selected');

              selectedOption
                .text(selectedOption.text() + ' - Loppu') //TODO: localize
                .addClass('sold-out');

              $('.js-product-add-to-cart-button', form).prop('disabled', true);
            }
          }
        },
        complete: function (xhr) {
          addingProduct = false;

          const token = xhr.responseJSON && xhr.responseJSON.length ? xhr.responseJSON[0].token : null;
          setTokens(token);
        }
      });
    });

  })(); //END PRODUCT PAGE

  /* ------------------------------------------------------------------------- */
  /*  Product page / rating form
  /* ------------------------------------------------------------------------- */

  (function () {

    //Don't bother if it's not article page
    if ($('article.p-product-page').length === 0) {
      return false;
    }

    var $form = $('.js-product-rating-form'),
      $starContainer = $('.js-product-rating-stars', $form),
      $stars = $('.js-product-rating-star', $starContainer),
      $textHint = $starContainer.next('.js-product-rating-description'),
      productId = $form.find('input[name="productId"]').val(),
      ratedProducts = storage.get('ratedProducts');

    // User has already rated this product
    if (ratedProducts && $.inArray(productId, ratedProducts) !== -1) {
      $('.js-review-form-container').addClass('u-hidden');
    }

    //Show descriptions on mouseenter
    $stars.on('mouseenter', function (e) {
      var $star = $(this);

      $star.prevAll().addBack().addClass('star-focused');
      $star.nextAll().removeClass('star-focused');

      $starContainer
        .removeClassStartsWith('container-focused-')
        .addClass('container-focused-' + $star.index());

      $textHint.text($star.find('label span').text());

      //Send rating on change
    }).on('change', 'input', function (e) {
      //Clear alerts
      hideAlert($form);

      var $star = $(this).closest('.js-product-rating-star');
      //Update star colors & texts
      $star.prevAll().addBack().addClass('star-selected');
      $star.nextAll().removeClass('star-selected');

      $starContainer
        .removeClassStartsWith('container-focused-')
        .removeClassStartsWith('container-selected-')
        .addClass('container-selected-' + $star.index());

      var txt = $star.find('label span').text();
      $textHint.addClass('stick').data('txt', txt).text(txt);
    });

    $form.on('submit', function (e) {
      var $currentForm = $(this);
      e.preventDefault();

      hideAlert($currentForm);

      // Get reviewed products
      ratedProducts = storage.get('ratedProducts');

      if (ratedProducts && $.inArray(productId, ratedProducts) !== -1) {
        // Already rated, dont allow another
        // This check will be made in backend too
        const errorText = $currentForm.attr('data-text-already-reviewed') || 'You have already reviewed this product';
        showAlert(errorText, $currentForm);
      } else {

        // Send form
        $.ajax({
          type: 'POST',
          url: $currentForm[0].action,
          data: $currentForm.serialize(),
          success: function (data) {
            if (data.status === 'SUCCESS') {
              // Disable form
              $currentForm.attr('disabled', true);

              // Show thank you message
              showAlert(data.txt, $currentForm, 'success');

              // Save rated product to storage
              if (!ratedProducts) {
                ratedProducts = [];
              }
              ratedProducts.push(data.productId);
              storage.set('ratedProducts', ratedProducts);

              // Update ratings
              updateRating(data);
              $('.js-product-rating-content').slideUp();

            } else if (data.status === 'ERROR') {
              showAlert(data.txt, $currentForm, 'error');
            }
          },
          complete: function(xhr) {
            const token = xhr.responseJSON && xhr.responseJSON.length ? xhr.responseJSON[0].token : null;
            setTokens(token);
          }
        });
      }
    });

    //Restore default state on mouseleave
    $starContainer.on('mouseleave', function () {
      $starContainer.removeClassStartsWith('container-focused-');
      $stars.removeClass('star-focused');

      if ($textHint.is('.stick')) {
        $textHint.text($textHint.data('txt'));
      } else {
        $textHint.text('');
      }
    });


    /**
     * Updates the rating stars with new values
     *
     * @param  {object} data  - An object containing the new average,
     *                            count and star html
     */
    function updateRating(data) {
      $('.js-product-rating-average').html(data.rating.starHtml);
      $('.js-product-rating-count').html('('+data.rating.count+')');

      const reviewItemTemplate = $('#product-review-item-teplate').html();
      const userReview = Mustache.render(reviewItemTemplate, {
        items: [{
          nickname: data.nickname,
          dateSubmitted: data.submitted,
          ratingStarHtml: data.ratingStarHtml,
          review: data.review
        }]
      });

      $('.js-product-review-list').append(userReview).removeClass('u-hidden');
    }

  })(); //END RATING FORM

  /* ------------------------------------------------------------------------- */
  /*  Checkout / Basket
  /* ------------------------------------------------------------------------- */

  (function () {
    var basketUrl = $('.basket-container').data('basket-url');

    /**
     * Updates the amount of product in basket.
     * Can be used to remove product from basket by setting amount = 0
     *
     * @param  {number}    ean       - EAN of the prodyct
     * @param  {number}    amount    - Amount of product wanted
     * @param  {Function}  callback  - Callback function to handle new data
     */
    function updateQuantity(ean, amount, callback) {
      //Get new token
      var token = updateToken();

      //Get data
      var s = $('.shopping-cart-table').data('s');

      $.ajax({
        type: 'POST',
        url: basketUrl,
        data: {
          products: [{
            ean: ean,
            amount: amount,
            replace: 1
          }],
          token: token,
          action: 'update',
          s: s
        },
        dataType: 'json',
        success: function (data) {
          data = data[0];
          if (typeof callback === 'function') {
            callback(data);
          }
        }, complete: function(xhr) {
          const token = xhr.responseJSON && xhr.responseJSON.length ? xhr.responseJSON[0].token : null;
          setTokens(token);
        }
      });
    }

    /**
     * Function that handles quantity change from:
     *
     * 1) increase button
     * 2) decrease button
     * 3) input field
     *
     * Will try to reserve products via ajax,
     * will only update value if reservation was successful.
     *
     * Shows error message if reservation failed.
     *
     * @param  {event} e - Event object
     */
    function quantityUIChanger(e) {
      e.preventDefault();

      var $elem = $(this);
      var $quantitySelectorField = $elem
        .closest('.js-quantity-selector')
        .find('.js-quantity-selector-field');
      var currentAmount = parseInt($quantitySelectorField.data('currentval'), 10);
      var newAmount;

      if ($elem.is('.js-quantity-selector-decrease')) {
        //Decrease by one
        newAmount = currentAmount - 1;
      } else if ($elem.is('.js-quantity-selector-increase')) {
        //Increase by one
        newAmount = currentAmount + 1;
      } else if ($elem.is('.js-quantity-selector-field')) {
        //Direct input from user
        newAmount = parseInt($quantitySelectorField.val(), 10);
      }

      // Don't allow negative amounts if min-attribute is present
      if ($quantitySelectorField.is('[min]') ? currentAmount > $quantitySelectorField.attr('min') : true) {

        //Prevent double entries on buttons and input
        var $qtyActions = $elem.closest('.js-quantity-selector').find('button, input');
        $qtyActions.prop('disabled', true);

        //Update new values to server
        updateQuantity(
          $elem.closest('tr').data('ean'),
          newAmount,
          function (data) {
            if (data.status === 'SUCCESS') {
              //Update baskets
              storage.set('myBasket', data.basket);
              updateHeaderBasket(data.basket);
              updateBasket(data.basket);

              //Enable all
              $qtyActions.prop('disabled', false);

              //Show & save new amount
              $quantitySelectorField.val(newAmount);
              $quantitySelectorField.data('currentval', newAmount);
            } else if (data.status === 'ERROR') {
              //Hide possible previous alerts and show new
              hideAlert($elem.closest('td'));
              showAlert(data.txt, $elem.closest('td'), 'error');

              //Return current amount
              $quantitySelectorField.val(currentAmount);

              //Enable all
              $qtyActions.prop('disabled', false);
            }
          }
        );
      }

    }


    if ($('body').is('.page-basket')) {

      //Always save newest status to localstorage on basket pageload
      $.ajax({
        type: 'GET',
        url: basketUrl,
        dataType: 'json',
        success: function (data) {
          if (data[0].status === 'SUCCESS') {
            storage.set('myBasket', data[0].basket);
            updateHeaderBasket(data[0].basket);
          }
        }
      });

      //Remove product
      $('.basket-container').on('click', 'a.remove-product', function (e) {
        e.preventDefault();

        //Prevent double clicks
        var $btn = $(this);
        $btn.hide().after($btn.data('wait'));

        var $row = $btn.closest('tr');

        //Variables
        var ean = $row.data('ean'),
          name = $row.data('name'),
          id = $row.data('id'),
          productColor = $row.data('color'),
          amount = parseInt($row.find('[name="amount"]').val());

        updateQuantity(ean, 0, function (data) {
          if (data.status === 'SUCCESS') {
            storage.set('myBasket', data.basket);
            updateHeaderBasket(data.basket);
            updateBasket(data.basket);

            if (data.basket.products.length === 0) {
              $('.checkout__button').remove();
            }

            mtmRemoveFromCart(data.basket.products);
            //Enhanced ecommerce
            if (GTM.isEnabled()) {
              GTM.removeFromCart(id, name, ean, amount, productColor);
            }

          } else if (data.status === 'ERROR') {
            hideAlert($btn.closest('td'));
            showAlert(data.txt, $btn.closest('td'), 'error');
          }
        });
      });

      //Quantity changer
      $('.basket-container')
        .on('click', '.js-quantity-selector-decrease, .js-quantity-selector-increase', quantityUIChanger)
        .on('change', '.js-quantity-selector-field', quantityUIChanger);

      //Discount code form
      var addingDiscount = false;
      $('body').on('submit', 'form.discount-code', function (e) {
        e.preventDefault();

        var $form = $(this);

        //Prevent double clicks
        if (addingDiscount) {
          return false;
        }

        addingDiscount = true;

        $.ajax({
          type: 'POST',
          url: $form.attr('action'),
          data: $form.serialize(),
          dataType: 'json',
          success: function (data) {
            if (data.status === 'SUCCESS') {
              //Refresh page
              window.location.reload();
            } else if (data.status === 'ERROR') {
              showAlert(data.txt, $form, 'error');
            }
          },
          complete: function () {
            addingDiscount = false;
          }
        });
      });
    }

  })(); //END BASKET PAGE

  /* ------------------------------------------------------------------------- */
  /*  Checkout / Delivery method page
  /* ------------------------------------------------------------------------- */

  (function () {
    var $deliveryMethods = $('#delivery-methods');
    var $deliveryMethodsContainer = $('.delivery-methods-container');
    var $getDeliveryMethods = $('#get-delivery-methods');
    var $getDeliveryMethodsContainer = $('.get-delivery-methods-action');
    var $deliveryMethodError = $('.delivery-method-error');
    var $altAddressToggle = $('#alt-address');
    var isAltAddress = false;
    var deliveryMethodsTemplate = $('#template-delivery-methods').html();
    var $altDeliveryAddressContainer = $('.delivery-address');
    var $paymentMethods = $('#payment-methods')
    var $deliveryForm = $('#order-create');

    // Alternative delivery address toggle is checked on pageload (e.g. validation failed)
    if ($altAddressToggle.is(':checked')) {
      isAltAddress = true;
    }

    /* FAMIWEB-280, submitting the payment / address form multiple times
    *  was causing system errors on Stage ( paymentNotInitialized )
    */
    $deliveryForm.one('submit', function() {
      $(this).find('button[type="submit"]').attr('disabled', 'disabled');
    });

    $paymentMethods.one('submit', function() {
      $(this).find('button[type="submit"]').attr('disabled', 'disabled');
    });

    // Alternate delivery address checkbox toggles delivery address visibility
    $altAddressToggle.on('change', function (e) {
      var $input = $(this);

      if ($input.prop('checked')) {
        $altDeliveryAddressContainer.removeClass('u-hidden');
        isAltAddress = true;
      } else {
        $altDeliveryAddressContainer.addClass('u-hidden');
        isAltAddress = false;
      }

      requireRefetch();
    });

    $getDeliveryMethods.on('click', function () {
      checkDeliveryMethods();
    });

    // On postal code change
    $('#order-postalcode, #order-country-code').on('change keyup', function () {
      // If postal code is changed after delivery methods are fetched, require re-fetch
      if (isAltAddress === false && $deliveryMethods.find('input[name="delivery_method"]').length) {
        requireRefetch();
      }
    });
    $('#order-delivery-postalcode, #order-delivery-country-code').on('change keyup', function () {
      if (isAltAddress === true && $deliveryMethods.find('input[name="delivery_method"]').length) {
        requireRefetch();
      }
    });

    // On delivery method change
    $deliveryMethodsContainer.on('change', 'input[name="delivery_method"]', function () {
      onDeliveryMethodSelect(this);
    });

    // On page load, check if there is existing deliverymethod
    let initialDeliveryMethod = $deliveryMethods.data('delivery-method');
    let initialPickupLocation = $deliveryMethods.data('pickup-location');
    if (initialDeliveryMethod) {
      checkDeliveryMethods();
    }

    /**
     * Deduce delivery country and zip code by alternative delivery address
     *
     * @returns {object} - Delivery country code and zip code
     */
    function getDeliveryCountryAndZip() {

      if (isAltAddress === false) {
        return {
          country: $('#order-country-code').val(),
          zip: $('#order-postalcode').val()
        }
      } else {
        return {
          country: $('#order-delivery-country-code').val(),
          zip: $('#order-delivery-postalcode').val()
        }
      }
    }

    /**
     * Executes delivery method list HTML rendering if delivery country and zip code is defined
     */
    function checkDeliveryMethods() {
      const delivery = getDeliveryCountryAndZip();
      if (typeof delivery === 'object' && delivery.country && delivery.zip) {
        $deliveryMethodError.removeClass('error-visible');
        $('.delivery-method-missing-error').remove();
        deliveryMethods();
      } else {
        $deliveryMethodError.addClass('error-visible');
      }
    }

    function requireRefetch() {
      initialDeliveryMethod = false;
      initialPickupLocation = false;

      $getDeliveryMethodsContainer.removeClass('u-hidden');
      $deliveryMethodsContainer.html('');
    }

    function onDeliveryMethodSelect(input) {
      // Stage cannot handle multiple selects with same name

      // Remove pickup location selector names
      $('select[name="pickup_location"]').removeAttr('name');

      // Add name to current pickup locator
      $(input).siblings('.pickup-locations').find('select').attr('name', 'pickup_location');
    }

    /**
     * Get product delivery methods
     * Renders HTML
     */
    function deliveryMethods() {
      const delivery = getDeliveryCountryAndZip();
      const lang = stageLanguage || $('html').attr('lang');

      $.ajax({
        cache: false,
        method: 'GET',
        dataType: 'json',
        url: '/stage-ajax/getDeliveryMethods?stage-language=' + lang,
        data: {
          country: delivery.country,
          postalCode: delivery.zip
        },
        success: function (result) {
          if (result.status === 'ERROR') {
            $deliveryMethodError.addClass('error-visible');
            $deliveryMethodsContainer.html('');
          } else {
            $getDeliveryMethodsContainer.addClass('u-hidden');
            var markUp = Mustache.render(deliveryMethodsTemplate, {
              methods: result.deliveryMethods
            });
            $deliveryMethodsContainer.html(markUp);

            // Check initial values
            if (initialDeliveryMethod) {
              // Initial delivery method
              const initialDeliveryMethodInput = $deliveryMethodsContainer.find('input[name="delivery_method"][value="' + initialDeliveryMethod + '"]');
              if (initialDeliveryMethodInput.length) {
                initialDeliveryMethodInput.trigger('click');
                onDeliveryMethodSelect(initialDeliveryMethodInput);

                // Initial pickup location
                if (initialPickupLocation) {
                  const initialPickupLocationOption = initialDeliveryMethodInput.parent().find('select[name="pickup_location"] option[value="' + initialPickupLocation + '"]');
                  if (initialPickupLocationOption.length) {
                    initialPickupLocationOption.prop('selected', true);
                  }
                }
              }
            }
          }
        },
        error: function () {
          $deliveryMethodError.addClass('error-visible');
          $deliveryMethodsContainer.html('');
        }
      });
    }

  })(); //END DELIVERY METHOD PAGE

})($, Mustache, store);
